import classNames from 'classnames';
import GiftCardItem from '../GiftCardItem';

import './GiftCardsList.scss';

const GiftCardsList = ({
  giftCardsList,
  onClick,
  className,
}) => (
  <div className={classNames('GiftCardsList', className)}>
    {giftCardsList.map(giftCardItem => (
      <GiftCardItem
        key={`giftCard-${giftCardItem.uid}`}
        giftCardItem={giftCardItem}
        onClick={onClick}
      />
    ))}
  </div>
);

export default GiftCardsList;
